import { TaxTraxTaxBillsResponse } from '../models';
import { Nullable } from 'common';
import { Property } from 'common/models';

export interface TaxTraxTaxBillsState {
  response: Nullable<TaxTraxTaxBillsResponse>;
  property: Nullable<Property>;
  loading: boolean;
}

export const TAXTRAX_POLICY_INFO_SET_LOADING =
  'TAXTRAX_POLICY_INFO_SET_LOADING';
export const TAXTRAX_POLICY_INFO_RESULT_SUCCESS =
  'TAXTRAX_POLICY_INFO_RESULT_SUCCESS';
export const TAXTRAX_RESET_RESULTS = 'TAXTRAX_RESET_RESULTS';

export const TAXTRAX_TAX_BILLS_ADD = 'TAXTRAX_TAX_BILLS_ADD';
export const TAXTRAX_TAX_BILLS_CLEAR = 'TAXTRAX_TAX_BILLS_CLEAR';
export const TAXTRAX_TAX_BILLS_LOADING = 'TAXTRAX_TAX_BILLS_LOADING';

export interface PolicyInfoState {
  loading: boolean;
}

export interface SetResultLoadingType {
  type: typeof TAXTRAX_POLICY_INFO_SET_LOADING;
  loading: boolean;
}

export interface ResetResultsType {
  type: typeof TAXTRAX_RESET_RESULTS;
}

interface TaxTraxTaxBillsAddAction {
  type: typeof TAXTRAX_TAX_BILLS_ADD;
  payload: { property: Property; response: TaxTraxTaxBillsResponse };
}

interface TaxTraxTaxBillsClearAction {
  type: typeof TAXTRAX_TAX_BILLS_CLEAR;
}

interface TaxTraxTaxBillsLoadingAction {
  type: typeof TAXTRAX_TAX_BILLS_LOADING;
  payload: boolean;
}

export type TaxTraxTaxBillsActionTypes =
  | TaxTraxTaxBillsAddAction
  | TaxTraxTaxBillsClearAction
  | TaxTraxTaxBillsLoadingAction;
